module.exports = __webpack_public_path__ + "static/media/zz.aa00a55e.svg";